import { Box, Hidden, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { format } from 'date-fns';

const useStyles = makeStyles(() => ({
  root: {
    marginTop: 'auto',
    paddingTop: '10px',
    paddingBottom: '10px',
    maxHeight: '75px',
    backgroundColor: '#434E59',
    color: 'white',
    textAlign: 'center',
  },
  copyrightHeading: {
    maxWidth: '75%',
    display: 'block',
    margin: '0 auto',
  },
  copyrightLink: {
    color: '#72e5ff',
    textDecoration: 'underline',
  },
  copyrightSeparator: {
    paddingLeft: '10px',
    paddingRight: '10px',
  },
}));

type Props = {
  hideOnMobile?: boolean;
};

const Footer = ({ hideOnMobile = false }: Props) => {
  const classes = useStyles();

  return (
    <Hidden only={hideOnMobile ? 'xs' : undefined}>
      <Box className={classes.root}>
        <Typography variant="caption" className={classes.copyrightHeading}>
          Copyright &copy; {format(new Date(), 'yyyy')} Trustate - All rights reserved. All
          documents, tasks, deadlines, and outputs generated via Trustate are attorney-directed
          tools and do not constitute legal advice. Attorneys are solely responsible for reviewing,
          validating, and ensuring all outputs are accurate, appropriate, and compliant with
          applicable laws, regulations, and licensing requirements.
        </Typography>
        <Typography variant="caption">
          <a
            className={classes.copyrightLink}
            href="https://www.trustate.com/privacy-policy"
            target="_blank"
            rel="noreferrer"
          >
            Privacy Policy
          </a>
        </Typography>
        <Typography variant="caption" className={classes.copyrightSeparator}>
          |
        </Typography>
        <Typography variant="caption">
          <a
            className={classes.copyrightLink}
            href="https://www.trustate.com/terms-of-service"
            target="_blank"
            rel="noreferrer"
          >
            Terms of Service
          </a>
        </Typography>
        <Typography variant="caption" className={classes.copyrightSeparator}>
          |
        </Typography>
        <Typography variant="caption">
          <a
            className={classes.copyrightLink}
            href="https://www.trustate.com/termsofuse"
            target="_blank"
            rel="noreferrer"
          >
            Terms of Use
          </a>
        </Typography>
      </Box>
    </Hidden>
  );
};

export default Footer;
